var portfolioPositionsList = {
	caption: "Posizioni di portafoglio",
	name: "Nome",
	isin: "ISIN",
	numberOfShares: "Quantità/Nominale",
	price: "Prezzo",
	dateTime: "Ora/Data",
	todayChange: "Var. oggi",
	unrealizedPerformance: "Perf. non realizzata.",
	marketValue: "Valore di mercato",
	purchaseValue: "Valore di acquisto",
	weight: "Ponderazione %",
	actions: "Azioni",
	noPositions: "Nessuna Posizione.",
	averagePurchasePrice: "Prezzo di acquisto medio"
};
var it = {
	portfolioPositionsList: portfolioPositionsList
};

export { it as default, portfolioPositionsList };
